<script setup lang="ts">
defineProps<{
  title: string
  /** Secondary line under title */
  description?: string
}>()
</script>

<template>
  <div class="ep-view">
    <header class="ep-page-head">
      <div class="ep-page-head-text">
        <h1 class="ep-page-title">{{ title }}</h1>
        <p v-if="description" class="ep-page-desc">{{ description }}</p>
        <slot name="below-desc" />
      </div>
      <div class="ep-page-extra">
        <slot name="actions" />
      </div>
    </header>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.ep-page-head-text {
  min-width: 0;
}
</style>
